export const IS_NAV_BAR_OPEN = 'isNavBarOpen'
